import { render, staticRenderFns } from "./AttributePage.vue?vue&type=template&id=5a4f339f&scoped=true&"
import script from "./AttributePage.vue?vue&type=script&lang=js&"
export * from "./AttributePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4f339f",
  null
  
)

export default component.exports